import { render, staticRenderFns } from "./MediaAttachmentList.vue?vue&type=template&id=c61a521e&scoped=true&"
import script from "./MediaAttachmentList.vue?vue&type=script&lang=js&"
export * from "./MediaAttachmentList.vue?vue&type=script&lang=js&"
import style0 from "./MediaAttachmentList.vue?vue&type=style&index=0&id=c61a521e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61a521e",
  null
  
)

export default component.exports